angular.module('impactx.MenuDirectives').controller('DeactivateRFQHSearchCtrl', [
    '$scope',
    'dataGen',
    '$context',
    'TranslationService',
    'RFQSearchService',
    'ToastService',
    '$redirect',
    '$location',
    '$securityManager',
    DeactivateRFQHSearchCtrl]);

function DeactivateRFQHSearchCtrl($scope, dataGen, $context, TranslationService, RFQSearchService, ToastService, $redirect, $location, $securityManager) {
    var self = this;
    self.showDeactivationButton = false;

    $scope.$watch(function() {
        return $context.hasRFQHSearch.value
    }, function(newValue) {
        self.showDeactivationButton = newValue;
        self.deactivateRFQSearchTranslation = TranslationService.get('deactivateRFQH');
    });

    self.deactivateRFQSearch = function() {
        var rfqhId = $context.hasRFQHSearch.id;
        var rfqcId = $context.rfqcSearch.id;
        var tenderId = $context.tenderSearch.id;
        var lotId = $context.lotSearch.id;
        var supplierId = $context.supplierSearch.id;
        RFQSearchService.deactivateRFQHSearch(true).then(function () {
            $context.refreshSearchInfo({}, dataGen, $context).then(function() {
                ToastService.openStandardToast(TranslationService.get('deactivatedRFQH'));
                if ($securityManager.isProcessAllowed("RFXView")) {
                    $redirect.redirectTo(null, "/rfxbuyer/" + rfqhId + "/" + rfqcId + "/" + supplierId + "/" +  tenderId + "/" + lotId + "/-1");
                }
                else {
                    $redirect.redirectTo(null, "/rfx/requestsupport/" + rfqhId + "/" + rfqcId + "/" + supplierId + "/" +  tenderId + "/" + lotId + "/-1");
                }
                $location.replace();
            });
        })
    };
}